var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.myTest)?[(_vm.myTestType === 'oql')?_c('test-query-oql',{attrs:{"input":_vm.myTest.input,"expected-response":_vm.myTest.expectedResponse,"test-suite-id":_vm.$route.params.testSuiteId,"query-id":Number(_vm.$route.params.queryId),"test-id":_vm.$route.params.testId}}):_vm._e()]:[_vm._v(" loading.... ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }